// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"FooterBreadcrumbs_listContainer__LqFno","breadcrumbs":"FooterBreadcrumbs_breadcrumbs__punaB","logo":"FooterBreadcrumbs_logo__pqoqb"};